export function getPaginationInitialState() {
    return {
        firstResult: 0,
        defaultNumberOfResults: 10,
        numberOfResults: 10,
        totalCountFiltered: 0,
    };
}
